import { render, staticRenderFns } from "./KeyDocuments.vue?vue&type=template&id=646aff67&"
import script from "./KeyDocuments.vue?vue&type=script&lang=js&"
export * from "./KeyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./KeyDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports